import FloatingDataEditorContainer from './FloatingDataEditorContainer';
import ProjectProvider from '../../core/providers/ProjectProvider';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FloatingDataManager extends Component {

  render() {

    const { project, data, graph, entitlements } = this.props;

    return (
      <ProjectProvider value={this.props.data}>
         <FloatingDataEditorContainer
          location={this.props.location}
          entitlements={entitlements}
          project={project}
          graph={graph}
          defaultLang={data.defaultLang} />
      </ProjectProvider>
    );
  }
}

FloatingDataManager.propTypes = {
  entitlements: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired
};

export default FloatingDataManager;
